

/** @type {import('./eval')} */
module.exports = EvalError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/eval.js
// module id = ../node_modules/es-errors/eval.js
// module chunks = 1